interface PainelSobrecargaProps {
  recursoNome: string;
  percentual: number;
  onFechar: () => void;
}

// SPEC-UX §10.2 — "Período em sobrecarga: segmento vermelho clicável ->
// painel com a composição da carga e duas ações: Rebalancear e Registrar
// override". V1: mostra a composição (percentual) e os 2 botões como
// affordance — as ações em si (editar alocações, modal de override com
// aprovador) navegam para os fluxos já existentes de Workload/Intake, não
// duplicam lógica aqui.
export function PainelSobrecarga({ recursoNome, percentual, onFechar }: PainelSobrecargaProps) {
  return (
    <div className="fixed inset-y-0 right-0 z-40 flex w-80 flex-col gap-4 border-l border-borda bg-superficie p-5 shadow-lg">
      <div className="flex items-start justify-between">
        <h3 className="text-sm font-semibold text-ink">Sobrecarga — {recursoNome}</h3>
        <button type="button" onClick={onFechar} className="text-grafite hover:text-ink" aria-label="Fechar">
          ✕
        </button>
      </div>
      <p className="text-sm text-status-vermelho">{percentual.toFixed(0)}% da capacidade — sobrealocado.</p>
      <div className="flex flex-col gap-2">
        <button type="button" className="rounded bg-aco px-3 py-2 text-xs font-medium text-white hover:bg-aco-700">
          Rebalancear alocações
        </button>
        <button type="button" className="rounded border border-borda px-3 py-2 text-xs font-medium text-ink hover:bg-borda/20">
          Registrar override
        </button>
      </div>
    </div>
  );
}
